<div class="row">
  <div class="col-sm-12">
    <div class="card">
      <div class="card-header">
        <h5>
          Invite a friend to be a panel member on the nDaba:
          <span class="text-primary" style="display: contents">
            {{ discussion.slug }}
          </span>
        </h5>

        <span>
          Only invite someone you know personally, who would be interested in
          <span class="text-primary" style="display: contents">
            {{ discussion.slug }}
          </span>
        </span>
        <div class="card-header-right">
          <i class="icofont icofont-spinner-alt-5"></i>
        </div>
      </div>

      <list-errors [hidden]="existingInvite && profile" [errors]="errors">
      </list-errors>

      <div class="card-block">
        <!-- Loader spinner -->
        <loader-animation
          [loading]="isSubmitting"
          [message]="'Loading profiles'"
        >
        </loader-animation>
        <!-- Loader spinner -->

        <div class="j-wrapper j-wrapper-640">
          <!-- Profile details end -->
          <div class="card" *ngIf="profile" [hidden]="isSubmitting">
            <div class="card-block">
              <div class="row">
                <div class="media-left">
                  <!-- Profile image start -->
                  <a [routerLink]="['/profile', profile.username]">
                    <img
                      *ngIf="profile.image"
                      class="profile-image"
                      [src]="profile.image"
                      alt="profile-image"
                    />
                    <img
                      *ngIf="!profile.image"
                      class="profile-image"
                      [src]="defaultUserImg"
                      alt="profile-image"
                    />
                  </a>
                </div>
                <!-- Profile image end -->

                <!-- Profile details start -->
                <div class="media-body text-align-left">
                  <div class="pull-left">
                    <a [routerLink]="['/profile', profile.username]">
                      <p>{{ profile.username | slice: 0:30 }}</p>
                    </a>
                  </div>
                  <div class="pull-left">
                    <span class="text-muted">
                      {{ profile.bio | slice: 0:35 }}...
                    </span>
                  </div>
                </div>
                <!-- Profile details end -->
              </div>
            </div>
          </div>
          <!-- Profile details end -->

          <!--Alert start -->
          <div
            class="alert alert-danger icons-alert"
            *ngIf="existingInvite !== null"
          >
            <button
              appRemoveAlert
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <i class="icofont icofont-close-line-circled"></i>
            </button>
            <p
              *ngIf="
                existingInvite !== null && existingInvite.status === 'accepted'
              "
            >
              This user already accepted invite
            </p>
            <p
              *ngIf="
                existingInvite !== null && existingInvite.status === 'requested'
              "
            >
              This user already received invite
            </p>
          </div>
          <!--Alert start -->

          <form class="j-pro form-control md-float-material" id="j-pro">
            <div class="j-content">
              <div class="j-row">
                <!-- start name -->
                <div class="j-span12 j-unit">
                  <div class="j-input">
                    <label class="j-icon-left" for="name">
                      <i class="icofont icofont-user-alt-2"></i>
                    </label>
                    <input
                      autocomplete="off"
                      [formControl]="inviteFriendField"
                      type="text"
                      id="contactName"
                      name="contactName"
                      placeholder="Please enter contact name"
                      class="name-group"
                      (keydown.enter)="$event.preventDefault()"
                    />
                  </div>
                </div>
                <!-- end name -->
              </div>
            </div>
            <!-- end /.content -->
            <div class="j-footer">
              <button
                [hidden]="
                  isSubmitting ||
                  (existingInvite !== null &&
                    existingInvite.status === 'accepted')
                "
                type="submit"
                class="btn btn-primary"
                (click)="openDiscussionInviteConfirmation()"
              >
                <i class="icofont icofont-paper-plane"></i>
                <span *ngIf="existingInvite === null"> Invite to nDaba </span>
                <span *ngIf="existingInvite !== null"> Revoke invite </span>
              </button>
            </div>
            <!-- end /.footer -->
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
